
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { UsuarioService } from 'src/app/services/shared/usuario.service';
import { Translators } from './../../../../services/shared/translators.service';
import { Router } from '@angular/router';
import { PopUpModalCustomService } from '@services/shared/popup-modal-custom.service';

@Component({
  selector: 'app-modal-modificar-clave',
  templateUrl: './modal-modificar-clave.component.html',
  styleUrls: ['./modal-modificar-clave.component.scss']
})
export class ModalModificarClaveUsersComponent implements OnInit {

    form: FormGroup;
    idioma: Subscription;
    showPassword: boolean;
    showPasswordConfirm: boolean;
    btnActualizar: boolean = false;

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public dataPersonas: any,
        private usuarioService: UsuarioService,
        private translatorService: Translators,
        private router: Router,
        private popup: PopUpModalCustomService,
        /* Modal Ref. */
        public dialogRef: MatDialogRef<ModalModificarClaveUsersComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string // recibo id de usuario para cambiar password
        /* Fin Modal Ref. */
    ) {
        this.idioma = this.translatorService.getIdiomaSeleccionado().subscribe(resp => {
            this.idioma = resp;
          });

        this.createForm();
     }

    ngOnInit(): void {
    }

    /* Creacion de formulario */
    createForm() {
        this.form = new FormGroup({
            password: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]),
            confirmPassword: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]),
    });
    }

    /* Cierro modal */
    closeModal(): void {
        this.dialogRef.close(this.data);
    }

    /* Modifico password*/
    async actualizarClave(){
        if (this.form.invalid){
            Object.values( this.form.controls ).forEach( control => {
                control.markAsTouched();
            });
            return;
        }

        if (this.form.value.password !== this.form.value.confirmPassword) {
            this.popup.abrirPopup({
                tipo: 'error',
                titulo: 'Las contraseñas no coinciden',
                mensaje: 'Verificá que ambas contraseñas sean iguales e intentá nuevamente.',
            });
            return;
        }

        this.btnActualizar = true;
        try {
            await this.usuarioService.updatePasswordUser(
                this.data,
                this.form.value.confirmPassword
            );

            this.closeModal();
            this.popup.abrirPopup({
                tipo: 'success',
                titulo: 'Contraseña modificada',
                mensaje: 'La contraseña del usuario se actualizó correctamente.',
                tiempoAutoCierre: 2200,
            });
            this.router.navigate(['/afiliados-listado']);
        } catch (error) {
            console.error('Error al modificar la contraseña:', error);
            this.popup.abrirPopup({
                tipo: 'error',
                titulo: 'No se pudo modificar',
                mensaje: 'No se pudo modificar la contraseña. Intentá nuevamente.',
            });
        } finally {
            this.btnActualizar = false;
        }
    }

    /* Validaciones */
    get passwordNoValido(){
        return this.form.get('password').invalid && this.form.get('password').touched;
    }

    get confirmPasswordNoValido(){
        const pass1 = this.form.get('password').value;
        const pass2 = this.form.get('confirmPassword').value;
        return ( pass1 === pass2 ) ? false : true;
    }

}
